import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { InvoiceV2Service } from './services/invoice-v2.service';

/**
 * Redirects legacy V1 unified documents (/dashboard/documents) to invoices-v2.
 * Preserves deep links: ?showDocument=<uuid> → /dashboard/invoices-v2/view?invoiceId=<id>
 */
@Injectable({ providedIn: 'root' })
export class DocumentsRedirectGuard implements CanActivate {
  constructor(
    private router: Router,
    private invoiceV2Service: InvoiceV2Service,
  ) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<UrlTree> | UrlTree {
    const showDocument = route.queryParamMap.get('showDocument');

    if (!showDocument) {
      return this.router.createUrlTree(['/dashboard/invoices-v2']);
    }

    return this.invoiceV2Service.getInvoiceByUuid(showDocument).pipe(
      map((response) => {
        const inv = response?.data != null ? response.data : response;
        const invoiceId = inv?.invoice_id;
        if (invoiceId == null) {
          return this.router.createUrlTree(['/dashboard/invoices-v2']);
        }
        return this.router.createUrlTree(['/dashboard/invoices-v2/view'], {
          queryParams: { invoiceId },
        });
      }),
      catchError(() => of(this.router.createUrlTree(['/dashboard/invoices-v2']))),
    );
  }
}
